import { tv } from '~/utils/tv'

export const checkboxLabelVariants = tv({
  base: 'line-clamp-4 min-h-small overflow-hidden text-left font-family-modern font-regular text-neutral-default',
  variants: {
    size: {
      md: 'pt-halfpulse text-threepulse leading-medium',
      ml: 'pt-halfpulse text-threeandhalfpulse leading-small',
      lg: 'pt-onepulse text-fourpulse leading-small',
      xl: 'pt-onepulse text-fourpulse leading-small',
    },
    hasError: {
      true: 'font-semibold',
    },
    hasDisabled: {
      true: 'text-neutral-disabled',
    },
    hasReadonly: {
      true: 'text-neutral-readonly',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
